import React from 'react';
import { getSpecificStoreClipboardCopy } from '@/url/storeLocator';
import Icon from '../Icon';
import TextSmall from '../Typography/TextSmall';

function StoreLocatorShareButton({
  handleClipboardCopy,
  item,
  setIsOpenShareStoreLocationModal,
  isOpenShareStoreLocationModal,
  title = '',
  text = '',
  fromStoreDetails = false,
  isCopied = false,
}) {
  const handleShare = async (e) => {
    e.stopPropagation();

    if (navigator.share) {
      const { store_code } = item;
      const url = getSpecificStoreClipboardCopy({ store_code });
      try {
        await navigator.share({
          title: title || 'Check this out!',
          text: text || 'I found something interesting:',
          url: url || window.location.href,
        });
      } catch (error) {
        console.error('Error sharing:', error);
      }
    } else {
      alert('Web Share API is not supported in your browser.');
    }
  };

  return (
    <div>
      {!fromStoreDetails ? (
        <div className="flex items-center gap-[8px] ">
          {isCopied ? (
            <TextSmall text="Copied!" className="text-tealgreen font-bold" />
          ) : (
            <Icon
              type="clipboard"
              className="cursor-pointer transition-transform hover:scale-125"
              onClick={(e) => handleClipboardCopy(e, item)}
            />
          )}

          <Icon
            type="share"
            onClick={(e) => {
              e.stopPropagation();
              setIsOpenShareStoreLocationModal(!isOpenShareStoreLocationModal);
            }}
            className="hidden lg:block cursor-pointer transition-transform hover:scale-125 size-[24px]"
          />

          <Icon
            type="share"
            onClick={(e) => handleShare(e)}
            className="block lg:hidden cursor-pointer transition-transform hover:scale-125 size-[24px]"
          />
        </div>
      ) : null}
    </div>
  );
}

export default StoreLocatorShareButton;
